import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  UncontrolledAlert
} from "reactstrap";
import { forgotPassword } from "../../actions/auth";
import { Helmet } from "react-helmet";
class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: ""
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentDidMount() {
  }

  render() {
    let { email } = this.state;
    let { 
        forgotPasswordRequest,
        forgotPasswordSuccessMsg,
        forgotPasswordErrorMsg,
        forgotPasswordErrors
    } = this.props; 

    forgotPasswordErrors = forgotPasswordErrors ? forgotPasswordErrors : {};
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>忘記密碼 - 美南新聞</title>
        </Helmet>
        <Col lg="5" md="7">
          {forgotPasswordErrorMsg && (
            <UncontrolledAlert color="danger" fade={false}>
              <span className="alert-inner--text">{forgotPasswordErrorMsg}</span>
            </UncontrolledAlert>
          )}
          {forgotPasswordSuccessMsg && (
            <UncontrolledAlert color="success" fade={false}>
              <span className="alert-inner--text">{forgotPasswordSuccessMsg}</span>
            </UncontrolledAlert>
          )}
          <Card className=" shadow border-0">
            <CardHeader className="bg-transparent">
              <h1 className="d-flex justify-content-center align-items-center">
              忘記密碼
              </h1>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-2">
              <Form onSubmit={this.onSubmit}>
                <FormGroup className="mb-3">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-email-83" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="email"
                      name="email"
                      id="loginEmail"
                      onChange={this.onInputChange}
                      value={email}
                      invalid={!!forgotPasswordErrors.email}
                      placeholder="郵箱"
                    />
                  </InputGroup>
                </FormGroup>
                <div className="text-center">
                  <Button
                    className="my-4 col-12"
                    color="danger"
                    type="submit"
                    disabled={forgotPasswordRequest}
                  >
                    發送重置密碼的鏈接
                  </Button>
                </div>
              </Form>
              <Row className="my-3">
                <Col className="text-center" xs="12">
                  <Link className="text-dark" to="login">
                    <small>返回登陸頁面</small>
                  </Link>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </>
    );
  }

  onInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  onSubmit(e) {
    e.preventDefault();
    let { email } = this.state;
    this.props.forgotPassword(email);
  }
}

const mapStateToProps = state => {
    let {
        forgotPasswordRequest,
        forgotPasswordSuccessMsg,
        forgotPasswordErrorMsg,
        forgotPasswordErrors} 
    = state.auth;
  return {
    forgotPasswordRequest,
    forgotPasswordSuccessMsg,
    forgotPasswordErrorMsg,
    forgotPasswordErrors
  };
};

const mapDispatchToProps = dispatch => {
  return {
    forgotPassword: (email) => dispatch(forgotPassword(email))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
